export default __webpack_public_path__ + "static/media/ic_stat2.9c827f70.svg";